import * as React from 'react';
import {signinRedirect } from 'shared/services/userService';

export default () => (<button onClick={signinRedirect}> Login </button>)